import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Modal, Button } from 'react-bootstrap';
import MyLoader from '../Spinner/MyLoader';
import SessionManager from '../Utils/SessionManager';
import '../css/Admin_css/admin-customize.css';
import COLORS from '../resources/colors/COLORS';
import myToast from '../Utils/MyToast';

const MdlSearchStudent = ({ actionClose, actionDone }) => {
  const [modalShow, setModalShow] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loadingStudent, setLoadingStudent] = useState(false);
  const [mSearchOption, setMSearchOption] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [keyword, setKeyword] = useState('');

  useEffect(() => {
    getReachOption();
  }, []);

  const getReachOption = useCallback(() => {
    setLoading(true);
    setMSearchOption([]);
    
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = 'getStudentSearchOptions.php?';
    const URL = process.env.REACT_APP_SERVER_NAME + process.env.REACT_APP_TARGET_DIR + FUNCTION_NAME;
    
    const params = {
      school_code: SCHOOL_CODE,
    };
    
    console.log("Search Options API Full URL: ", `${URL}${new URLSearchParams(params).toString()}`);
    console.log("Search Options API Params: ", params);

    axios.get(URL, {
      params: params
    })
    .then(res => res.data)
    .then((response) => {
      setLoading(false);
      let api_status = response.api_status;
      
      if (api_status === "OK") {
        setMSearchOption(response.data || []);
      } else {
        let api_remark = response.api_remark;
        myToast.notify_warning(api_remark);
      }
    })
    .catch((error) => {
      setLoading(false);
      console.error("getReachOption error:", error);
      myToast.notify_error("Failed to load search options");
    });
  }, []);

  const isAnyOptionSelected = useCallback(() => {
    return mSearchOption.some(item => item.isChecked === 'true');
  }, [mSearchOption]);

  const onCheckedSearchOption = useCallback((e, position) => {
    const isChecked = e.target.checked;
    const newArray = [...mSearchOption];
    
    if (isChecked) {
      newArray[position]['isChecked'] = 'true';
      setMSearchOption(newArray);
    } else {
      newArray[position]['isChecked'] = 'false';
      setMSearchOption(newArray);
      
      if (!isAnyOptionSelected()) {
        myToast.notify_warning("Select at least one option");
        newArray[position]['isChecked'] = 'true';
        setMSearchOption(newArray);
      }
    }
  }, [mSearchOption, isAnyOptionSelected]);

  const getStudentList = useCallback(() => {
    if (!keyword.trim()) {
      myToast.notify_warning("Please enter a search keyword");
      return;
    }

    if (!isAnyOptionSelected()) {
      myToast.notify_warning("Please select at least one search option");
      return;
    }

    setLoadingStudent(true);
    setStudentList([]);
    
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const mOption = mSearchOption
      .filter(item => item.isChecked === 'true')
      .map(item => item.search_option);
    const OPTION = JSON.stringify(mOption);

    const FUNCTION_NAME = 'searchStudentList.php?';
    const URL = process.env.REACT_APP_SERVER_NAME + process.env.REACT_APP_TARGET_DIR + FUNCTION_NAME;
    
    const params = {
      keyword: keyword,
      option: OPTION,
      school_code: SCHOOL_CODE,
    };
    
    console.log("Search API Full URL: ", `${URL}${new URLSearchParams(params).toString()}`);
    console.log("Search API Params: ", params);

    axios.get(URL, {
      params: params
    })
    .then(res => res.data)
    .then((response) => {
      setLoadingStudent(false);
      let api_status = response.api_status;
      
      if (api_status === "OK") {
        setStudentList(response.data || []);
        if (!response.data || response.data.length === 0) {
          myToast.notify_info("No students found matching your search criteria");
        }
      } else {
        let api_remark = response.api_remark;
        myToast.notify_warning(api_remark);
      }
    })
    .catch((error) => {
      setLoadingStudent(false);
      console.error("getStudentList error:", error);
      myToast.notify_error("Failed to search students");
    });
  }, [keyword, mSearchOption, isAnyOptionSelected]);

  const handleSearch = useCallback((e) => {
    e.preventDefault();
    getStudentList();
  }, [getStudentList]);

  const handleSelectedStudent = useCallback((student_id, selected_item) => {
    if (actionDone) {
      actionDone(
        student_id,
        selected_item,
        selected_item.class && selected_item.class[0] ? selected_item.class[0].session_id : '',
        selected_item.class && selected_item.class[0] ? selected_item.class[0].session_name : ''
      );
    }
  }, [actionDone]);

  const handleClose = useCallback(() => {
    setModalShow(false);
    if (actionClose) {
      actionClose();
    }
  }, [actionClose]);

  const handleKeywordChange = useCallback((e) => {
    setKeyword(e.target.value);
  }, []);

  return (
    <Modal
      show={modalShow}
      onHide={handleClose}
      animation={false}
      size="xl"
      aria-labelledby="search-student-title"
      centered
      backdrop="static"
      backdropClassName="custom-backdrop"
      contentClassName="custom-modal-content"
      style={{
        borderRadius: "20px",
        overflow: "hidden",
      }}
      dialogClassName="modal-dialog-scrollable"
    >
      <div
        style={{
          background: COLORS.white,
          borderRadius: "20px",
          overflow: "hidden",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
          border: "none",
          display: "flex",
          flexDirection: "column",
          maxHeight: "90vh",
        }}
      >
        <Modal.Header
          closeButton
          style={{
            background: `linear-gradient(135deg, ${COLORS.primary_color_shade7 || "#01579B"} 0%, ${COLORS.primary_color_shade8 || "#0277BD"} 100%)`,
            color: COLORS.white,
            border: "none",
            padding: "16px 20px",
            position: "relative",
            overflow: "hidden",
            flexShrink: 0,
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "-20px",
              right: "-20px",
              width: "80px",
              height: "80px",
              background: "rgba(255, 255, 255, 0.1)",
              borderRadius: "50%",
              filter: "blur(15px)",
            }}
          />
          <div style={{ position: "relative", zIndex: 1, width: "100%" }}>
            <Modal.Title
              id="search-student-title"
              style={{
                fontSize: "20px",
                fontWeight: "700",
                margin: 0,
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <i className="fa fa-search" style={{ fontSize: "18px" }}></i>
              Search By Name
            </Modal.Title>
          </div>
        </Modal.Header>

        <Modal.Body
          style={{
            padding: "16px",
            background: `linear-gradient(to bottom, ${COLORS.grey1 || "#F5F5F5"} 0%, ${COLORS.white} 100%)`,
            border: "none",
            overflowY: "auto",
            overflowX: "hidden",
            flex: "1 1 auto",
          }}
        >
          {loading ? (
            <MyLoader />
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              {/* Search Options */}
              <div>
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: COLORS.primary_color_shade7,
                    marginBottom: "12px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <i className="fa fa-filter" style={{ fontSize: "14px" }}></i>
                  Select Search Options
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
                    gap: "8px",
                  }}
                >
                  {mSearchOption && mSearchOption.map((item, index) => {
                    const handleCardClick = () => {
                      // Toggle checkbox when clicking the card
                      const newArray = [...mSearchOption];
                      const newChecked = item.isChecked !== 'true';
                      newArray[index]['isChecked'] = newChecked ? 'true' : 'false';
                      
                      // Validate at least one option is selected
                      if (!newChecked) {
                        const hasOtherSelected = newArray.some((opt, idx) => idx !== index && opt.isChecked === 'true');
                        if (!hasOtherSelected) {
                          myToast.notify_warning("Select at least one option");
                          newArray[index]['isChecked'] = 'true';
                        }
                      }
                      setMSearchOption(newArray);
                    };

                    return (
                    <div
                      key={index}
                      onClick={handleCardClick}
                      style={{
                        padding: "12px 16px",
                        borderRadius: "10px",
                        background: item.isChecked === 'true'
                          ? `linear-gradient(135deg, ${COLORS.primary_color_shade1 || "#B3E5FC"} 0%, ${COLORS.primary_color_shade3 || "#4FC3F7"} 100%)`
                          : COLORS.white,
                        border: `2px solid ${item.isChecked === 'true' ? COLORS.primary_color_shade5 : COLORS.grey3}`,
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        boxShadow: item.isChecked === 'true'
                          ? "0 4px 12px rgba(3, 169, 244, 0.2)"
                          : "0 2px 4px rgba(0, 0, 0, 0.05)",
                      }}
                      onMouseEnter={(e) => {
                        if (item.isChecked !== 'true') {
                          e.currentTarget.style.borderColor = COLORS.primary_color_shade3;
                          e.currentTarget.style.transform = "translateY(-2px)";
                          e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (item.isChecked !== 'true') {
                          e.currentTarget.style.borderColor = COLORS.grey3;
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                        }
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={item.isChecked === 'true'}
                        onChange={(e) => onCheckedSearchOption(e, index)}
                        onClick={(e) => e.stopPropagation()}
                        style={{
                          width: "18px",
                          height: "18px",
                          cursor: "pointer",
                          accentColor: COLORS.primary_color_shade7,
                        }}
                      />
                      <span
                        style={{
                          fontSize: "14px",
                          fontWeight: "600",
                          color: item.isChecked === 'true' ? COLORS.primary_color_shade7 : COLORS.black8,
                          flex: 1,
                        }}
                      >
                        {item.search_caption}
                      </span>
                    </div>
                    );
                  })}
                </div>
              </div>

              {/* Search Input */}
              <div>
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: COLORS.primary_color_shade7,
                    marginBottom: "12px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <i className="fa fa-keyboard-o" style={{ fontSize: "14px" }}></i>
                  Enter Search Keyword
                </div>
                <form onSubmit={handleSearch} style={{ width: "100%" }}>
                  <div style={{ display: "flex", gap: "10px", width: "100%", alignItems: "stretch" }}>
                    <input
                      type="text"
                      id="KEYWORD"
                      placeholder="Enter First Name, Address, Admission No, etc."
                      value={keyword}
                      onChange={handleKeywordChange}
                      style={{
                        flex: 1,
                        padding: "12px 16px",
                        fontSize: "15px",
                        borderRadius: "10px",
                        border: `2px solid ${COLORS.grey3}`,
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                        transition: "all 0.2s ease",
                        outline: "none",
                        minWidth: "200px",
                        height: "auto",
                        minHeight: "44px",
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = COLORS.primary_color_shade5;
                        e.target.style.boxShadow = "0 4px 12px rgba(3, 169, 244, 0.15)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = COLORS.grey3;
                        e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                      }}
                    />
                    <Button
                      type="submit"
                      onClick={handleSearch}
                      disabled={loadingStudent}
                      style={{
                        padding: "12px 24px",
                        borderRadius: "10px",
                        background: loadingStudent ? COLORS.grey4 : COLORS.primary_color_shade5,
                        border: `2px solid ${loadingStudent ? COLORS.grey5 : COLORS.primary_color_shade7}`,
                        color: COLORS.white,
                        fontSize: "15px",
                        fontWeight: "600",
                        boxShadow: loadingStudent ? "none" : "0 4px 12px rgba(3, 169, 244, 0.3)",
                        transition: "all 0.2s ease",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        whiteSpace: "nowrap",
                        minWidth: "120px",
                        flexShrink: 0,
                        cursor: loadingStudent ? "not-allowed" : "pointer",
                        height: "auto",
                        minHeight: "44px",
                        position: "relative",
                        zIndex: 1,
                        visibility: "visible",
                        opacity: 1,
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow = "0 6px 16px rgba(3, 169, 244, 0.4)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "0 4px 12px rgba(3, 169, 244, 0.3)";
                      }}
                    >
                      {loadingStudent ? (
                        <>
                          <div
                            style={{
                              width: "16px",
                              height: "16px",
                              border: "2px solid #ffffff",
                              borderTop: "2px solid transparent",
                              borderRadius: "50%",
                              animation: "spin 1s linear infinite",
                            }}
                          />
                          <span>Searching...</span>
                        </>
                      ) : (
                        <>
                          <i className="fa fa-search"></i>
                          <span>Search</span>
                        </>
                      )}
                    </Button>
                  </div>
                </form>
              </div>

              {/* Student List */}
              {studentList.length > 0 ? (
                <div>
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "600",
                      color: COLORS.primary_color_shade7,
                      marginBottom: "12px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <i className="fa fa-users" style={{ fontSize: "14px" }}></i>
                    Search Results ({studentList.length})
                  </div>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
                      gap: "12px",
                    }}
                  >
                    {studentList.map((item, index) => (
                      <div
                        key={index}
                        onClick={() => handleSelectedStudent(item.student_enrollment_no, item)}
                        style={{
                          background: `linear-gradient(135deg, ${COLORS.white} 0%, ${COLORS.grey0} 100%)`,
                          borderRadius: "12px",
                          padding: "16px",
                          border: `1px solid ${COLORS.primary_color_shade5}`,
                          cursor: "pointer",
                          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                          display: "flex",
                          gap: "12px",
                          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                          position: "relative",
                          overflow: "hidden",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.borderColor = COLORS.primary_color_shade7;
                          e.currentTarget.style.transform = "translateY(-2px)";
                          e.currentTarget.style.boxShadow = "0 8px 20px rgba(3, 169, 244, 0.15)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.borderColor = COLORS.primary_color_shade5;
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                        }}
                      >
                        <div
                          style={{
                            width: "60px",
                            height: "60px",
                            borderRadius: "50%",
                            overflow: "hidden",
                            background: `linear-gradient(135deg, ${COLORS.primary_color_shade1}, ${COLORS.primary_color_shade3})`,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                            border: `1px solid ${COLORS.primary_color_shade3}`,
                            position: "relative",
                          }}
                        >
                          <img
                            src={item.student_img_path}
                            alt={item.stu_name}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                            onError={(e) => {
                              e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(item.stu_name)}&background=${COLORS.primary_color_shade5.replace('#', '')}&color=fff&size=60`;
                            }}
                          />
                        </div>
                        
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div
                            style={{
                              fontSize: "16px",
                              fontWeight: "700",
                              color: COLORS.primary_color_shade7,
                              marginBottom: "6px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              letterSpacing: "-0.3px",
                            }}
                          >
                            {item.stu_name}
                          </div>
                          
                          <div
                            style={{
                              fontSize: "12px",
                              color: COLORS.black6,
                              marginBottom: "8px",
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <i
                              className="fa fa-user"
                              style={{
                                color: COLORS.primary_color_shade5,
                                fontSize: "10px",
                              }}
                            />
                            <span
                              style={{
                                fontWeight: "500",
                                color: COLORS.black7,
                              }}
                            >
                              {item.father_name}
                            </span>
                          </div>
                          
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                              marginTop: "8px",
                              flexWrap: "wrap",
                            }}
                          >
                            <div
                              style={{
                                padding: "4px 8px",
                                borderRadius: "6px",
                                background: `linear-gradient(135deg, ${COLORS.primary_color_shade1}, ${COLORS.primary_color_shade3})`,
                                color: COLORS.primary_color_shade7,
                                fontSize: "10px",
                                fontWeight: "700",
                                display: "flex",
                                alignItems: "center",
                                gap: "3px",
                                boxShadow: "0 2px 4px rgba(3, 169, 244, 0.2)",
                              }}
                            >
                              <i className="fa fa-id-card" style={{ fontSize: "8px" }} />
                              {item.student_enrollment_no}
                            </div>
                            
                            <div
                              style={{
                                padding: "4px 8px",
                                borderRadius: "6px",
                                background: `linear-gradient(135deg, ${COLORS.primary_color_shade6}, ${COLORS.primary_color_shade7})`,
                                color: COLORS.white,
                                fontSize: "10px",
                                fontWeight: "700",
                                display: "flex",
                                alignItems: "center",
                                gap: "3px",
                                boxShadow: "0 2px 4px rgba(2, 136, 209, 0.2)",
                              }}
                            >
                              <i className="fa fa-hashtag" style={{ fontSize: "8px" }} />
                              Roll: {item.class && item.class[0] ? item.class[0].student_roll_no || 'N/A' : 'N/A'}
                            </div>
                            
                            <div
                              style={{
                                padding: "4px 8px",
                                borderRadius: "6px",
                                background: `linear-gradient(135deg, ${COLORS.primary_color_shade1}, ${COLORS.primary_color_shade3})`,
                                color: COLORS.primary_color_shade7,
                                fontSize: "10px",
                                fontWeight: "700",
                                display: "flex",
                                alignItems: "center",
                                gap: "3px",
                                boxShadow: "0 2px 4px rgba(3, 169, 244, 0.2)",
                              }}
                            >
                              <i className="fa fa-graduation-cap" style={{ fontSize: "8px" }} />
                              {item.class && item.class[0] 
                                ? (item.class[0].section_id === 'No'
                                  ? item.class[0].class_name || 'N/A'
                                  : `${item.class[0].class_name || 'N/A'}:${item.class[0].section_name || 'N/A'}`)
                                : 'N/A'
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : null}
            </div>
          )}
        </Modal.Body>
      </div>

      {/* Custom CSS */}
      <style>{`
        .custom-backdrop {
          background-color: rgba(0, 0, 0, 0.6);
          backdrop-filter: blur(4px);
        }
        .custom-modal-content {
          border-radius: 20px;
          overflow: hidden;
          border: none;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
          display: flex;
          flex-direction: column;
          max-height: 90vh;
        }
        .modal-content {
          border-radius: 20px;
          overflow: hidden;
          border: none;
        }
        .modal-dialog {
          margin: 1.75rem auto;
          max-height: 90vh;
        }
        .modal.show .modal-dialog {
          transform: none;
        }
        .modal-header {
          border-radius: 20px 20px 0 0;
        }
        .modal-header .btn-close {
          filter: brightness(0) invert(1);
          opacity: 0.9;
          z-index: 2;
        }
        .modal-header .btn-close:hover {
          opacity: 1;
        }
        /* Custom scrollbar */
        .modal-body::-webkit-scrollbar {
          width: 8px;
        }
        .modal-body::-webkit-scrollbar-track {
          background: ${COLORS.grey1};
          border-radius: 10px;
        }
        .modal-body::-webkit-scrollbar-thumb {
          background: ${COLORS.primary_color_shade3};
          border-radius: 10px;
        }
        .modal-body::-webkit-scrollbar-thumb:hover {
          background: ${COLORS.primary_color_shade5};
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </Modal>
  );
};

export default MdlSearchStudent;
